import { EmojiResource } from '@atlaskit/emoji/resource';
import { ProviderFactory } from '@atlaskit/editor-common/provider-factory';

import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider.ts';

export const getDataProviders = (cloudId: string, userId: string | null) => {
	const dataProviders = ProviderFactory.create({});
	dataProviders.setProvider('emojiProvider', getEmojiProvider(EmojiResource, { cloudId, userId }));
	return dataProviders;
};
